// Shared role/permission gate used by row actions (ListView, DetailHeaderCard)
// and, via AddFormV1/EditFormV1, by field-level visiblePermission/editablePermission.
// A permission value looks like "<module>.<key>" (e.g. "submission.viewRate") and
// is checked against localStorage.menuPermission, the module-permission map the
// login API computes server-side from the user's role. No config = unrestricted.

export function isActionValueAllowed(value) {
  if (value === undefined || value === null) return true;
  if (typeof value === 'object') {
    return isActionValueAllowed(value.permission ?? value.allowed ?? value.value);
  }
  return value !== false && value !== 0 && value !== '0';
}

export function roleAllowsAction(permission, moduleName) {
  if (!permission) return true;
  try {
    const permissions = JSON.parse(localStorage.getItem('menuPermission') || '{}');
    const [configuredModule, configuredKey] = String(permission).split('.');
    const moduleKey = configuredModule || String(moduleName || '').replace(/s$/i, '');
    const modulePermissions = permissions[moduleKey]
      ?? permissions[String(moduleName || '')]
      ?? permissions[String(moduleName || '').replace(/s$/i, '')]
      ?? {};
    return isActionValueAllowed(modulePermissions[configuredKey]);
  } catch {
    return true;
  }
}
